module.exports = __webpack_public_path__ + "static/media/21.e3a07df8.png";